import React from "react";
import ProductDetailProductAds from "../ProductDetailProductAds";
import ReplacementsAd from "../ReplacementsAd";
import ResourcesAndDownloads from "~/common/ResourcesAndDownloads/ResourcesAndDownloads";
import SpecificationTable from "../SpecificationTable";
import CompatibleModels from "../CompatibleModels";
import EquivalentItems from "../EquivalentItems";
import { ProductDetailPageResult } from "../ProductDetailPageResult";

interface SideColumnBottomSectionProps {
  activeTemplate: ProductDetailPageResult;
  isExpandedDescriptionTemplate: boolean;
}

export const SideColumnBottomSection = ({
  activeTemplate,
  isExpandedDescriptionTemplate,
}: Readonly<SideColumnBottomSectionProps>) => {
  const {
    itemNumber,
    productAds,
    hasPartsOrAccessories,
    compatibleWithLink,
    manufacturerItemNumberDisplayText = "",
    productDocuments,
    productDisclaimer,
    linkedResources,
    specificationTable,
    unitOfMeasure,
    unitsPerPackaging,
    weightInPounds,
    compatibleModelItems,
    compatibleModelItemsCount,
    equivalentItems,
  } = activeTemplate;

  const isVirtualGroupMaster =
    activeTemplate.groupingAttributes.isGroupMaster &&
    activeTemplate.groupingAttributes.isVirtual;

  return (
    <div className="side-col aside xs:mb-4">
      {isExpandedDescriptionTemplate && productAds && (
        <ProductDetailProductAds
          ads={productAds}
          isExpandedDescriptionTemplate
        />
      )}
      {hasPartsOrAccessories && !isVirtualGroupMaster && (
        <ReplacementsAd
          link={compatibleWithLink}
          manufacturerItemNumberDisplayText={manufacturerItemNumberDisplayText}
        />
      )}
      {(productDocuments?.length > 0 ||
        (productDisclaimer?.warrantyInformation &&
          productDisclaimer?.showWarrantyInformation) ||
        (linkedResources && linkedResources.length > 0)) && (
        <ResourcesAndDownloads
          manufacturerItemNumberDisplayText={manufacturerItemNumberDisplayText}
          productDocuments={productDocuments}
          productDisclaimer={productDisclaimer}
          linkedResources={linkedResources}
        />
      )}
      {isExpandedDescriptionTemplate && (
        <SpecificationTable
          itemNumber={itemNumber}
          specifications={specificationTable?.specifications ?? []}
          name={specificationTable?.name ?? ""}
          unitOfMeasure={unitOfMeasure}
          unitsPerPackaging={unitsPerPackaging}
          showInSidebar
          weightInPounds={weightInPounds}
        />
      )}
      {compatibleModelItems?.length > 0 && (
        <CompatibleModels
          compatibleModelItems={compatibleModelItems}
          compatibleModelItemsCount={compatibleModelItemsCount}
          itemNumber={itemNumber}
        />
      )}
      {equivalentItems?.length > 0 && (
        <EquivalentItems equivalentItems={equivalentItems} />
      )}
    </div>
  );
};
